<template>
    <v-dialog
        v-model="visibleDialog"
        width="1000"
    >
    <v-container fluid style="padding:0; background-color: white; border-radius: 2px;">
        <v-layout column>
            <v-flex shrink>
                <v-layout row align-center style="background-color: rgba(31, 81, 206, .3);">
                    <v-flex shrink>
                        <v-btn
                            icon
                            @click="receiverListVisible = !receiverListVisible"
                        >
                            <v-icon>dehaze</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex grow>
                        <div class="text-xs-center" style="color:white;">(Nur systeminterne Kommunikation)</div>
                    </v-flex>
                    <v-flex shrink>
                        <v-btn
                            icon
                            @click="visibleDialog = !visibleDialog"
                        >
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex grow>
                <v-layout row>
                    <v-flex :shrink="selectedReceiver.receiverUserId != ''" :grow="selectedReceiver.receiverUserId == ''" style=" border-right: 2px solid rgb(230, 230, 230);">
                        <v-expand-x-transition>
                            <v-card flat v-show="!receiverListVisible || selectedReceiver.receiverUserId == ''" style="height: 100%;">
                                <v-card-title style="border-bottom: 2px solid rgb(230, 230, 230);">
                                    <v-text-field
                                        label="Nach Personen suchen"
                                        placeholder="Begriff eingeben"
                                        v-model="search"
                                    ></v-text-field>
                                </v-card-title>
                                <v-card-text style="max-height: 400px; height: 100%; overflow-y: auto;">
                                    <v-list two-line>
                                        <template v-for="(receiver, index) of filteredReceivers">
                                            
                                            <v-list-tile
                                                :key="receiver.receiverEmail + index"
                                                @click="selectReceiver(receiver)"
                                                :class="[receiver.receiverUserId == selectedReceiver.receiverUserId ? 'selected-user' : '']"
                                            >
                                                <v-badge color="red" left >
                                                    <template v-slot:badge>
                                                        <span v-if="showNotReadCount(receiver.receiverUserId) != 0">
                                                            {{showNotReadCount(receiver.receiverUserId)}}
                                                        </span>
                                                    </template>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>
                                                            <template v-if="receiver.isActivated == 1">
                                                                {{receiver.salutation}} {{receiver.firstname}} {{receiver.lastname}}
                                                            </template>
                                                            <template></template>
                                                        </v-list-tile-title>
                                                        <v-list-tile-sub-title>{{ receiver.receiverEmail }},
                                                            <template v-if="receiver.rolesString.includes('DSB')"> DSB</template>
                                                            <template v-if="receiver.rolesString.includes('DSB') && receiver.rolesString.includes('DSK')">,</template>
                                                            <template v-if="receiver.rolesString.includes('DSK')"> DSK</template>
                                                            <template v-if="receiver.rolesString.includes('DSK') && receiver.rolesString.includes('DST')">,</template>
                                                            <template v-if="receiver.rolesString.includes('DST')"> DST</template>
                                                        </v-list-tile-sub-title>
                                                    </v-list-tile-content>
                                                </v-badge>
                                                
                                            </v-list-tile>
                                        </template>
                                    </v-list>
                                </v-card-text>
                            </v-card>
                        </v-expand-x-transition>
                    </v-flex>

                    <v-flex style="min-height: 500px;" :shrink="selectedReceiver.receiverUserId == ''" :grow="selectedReceiver.receiverUserId != ''">
                        <v-layout column style="height: 100%;">
                            <v-flex grow>
                                <v-layout 
                                    v-if="preparedMessages.length != 0 && selectedReceiver.receiverUserId != ''"
                                    @click="receiverListVisible = false" 
                                    column 
                                    style="max-height: 500px; overflow-y: auto;"
                                    id="messages"
                                    >
                                    <v-flex shrink v-for="(message, index) of preparedMessages" :key="message.senderUserId + message.creationTime + index">
                                        <v-card style="margin: 5px;" :id="index+1 == preparedMessages.length? 'lastMessage' : false">
                                            <v-card-title style="background-color: rgba(31, 81, 206, .1);">
                                                <v-layout column>
                                                    <v-flex>
                                                        <v-layout row wrap>
                                                            <v-flex>
                                                                Sender: {{message.senderFirstname}} {{message.senderLastname}}
                                                            </v-flex>
                                                            <v-spacer></v-spacer>
                                                            <v-flex>
                                                                Empfänger: 
                                                                    <template v-if="message.receiverFirstname">{{message.receiverFirstname}} {{message.receiverLastname}}</template>
                                                                    <template v-else>
                                                                        {{message.receiverEmail}}
                                                                        <div style="font-size: 10px;">(Kein E-Mail-Versand, nur systeminterne Kommunikation)</div>
                                                                    </template>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex>
                                                        {{message.date}}, {{message.time}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-title>
                                            <v-card-text>
                                                <v-layout column>
                                                    <v-flex shrink style="padding-bottom: 5px; border-bottom: 1px solid rgb(210,210,210)">
                                                        <span>{{message.subject}}</span>
                                                    </v-flex>
                                                    <v-flex grow style="white-space: pre;">{{message.message}}</v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                                <v-layout align-center justify-center column v-else-if="preparedMessages.length == 0">
                                    <v-flex 
                                        v-if="selectedReceiver.receiverId != '' 
                                            && Object.keys(selectedReceiver).includes('firstname') 
                                            && Object.keys(selectedReceiver).includes('lastname')" style="padding-top: 100px;">
                                        <span
                                            v-if="Object.keys(selectedReceiver).includes('firstname') 
                                                && Object.keys(selectedReceiver).includes('lastname')"
                                            >Derzeit gibt es noch keine Kommunikation mit 

                                            <template v-if="selectedReceiver.lastname">{{(selectedReceiver.firstname + ' ' + selectedReceiver.lastname).trim()}}</template>
                                            <template v-else>{{(selectedReceiver.receiverEmail).trim()}}</template>.</span>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <v-spacer></v-spacer>

                            <v-flex shrink>
                                <v-layout column>
                                    <v-flex shrink style="background-color: rgba(31, 81, 206, .3);">
                                        <v-layout row align-center fill-height @click="receiverListVisible = false">
                                            <v-flex grow style="padding: 5px 0 5px 16px;">
                                                <v-layout column>
                                                    <v-flex shrink>
                                                        <v-text-field
                                                        style="background-color: white; border-radius: 4px;"
                                                        flat
                                                        hide-details
                                                        label="Betreff"
                                                        v-model="msg.subject"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex grow>
                                                        <v-textarea
                                                            style="background-color: white; border-radius: 4px;"
                                                            flat
                                                            no-resize
                                                            hide-details
                                                            label="Nachricht"
                                                            v-model="msg.message"
                                                        ></v-textarea>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex shrink>
                                                <v-layout column align-center>
                                                    <v-flex>
                                                        <v-btn class="send-button" @click="sendMessage" icon dark style="transform: rotate(-30deg);">
                                                            <v-icon>
                                                                send
                                                            </v-icon>
                                                        </v-btn>
                                                    </v-flex>
                                                    <v-flex style="padding: 0 4px; color: white; font-size: 12px; width: 130px;">
                                                        <div>(Kein E-Mail-Versand)</div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>

            <!-- <v-flex shrink style="background-color: rgba(31, 81, 206, .3);">
                <v-layout row align-center fill-height @click="receiverListVisible = false">
                    <v-flex grow style="padding: 5px 0 5px 16px;">
                        <v-layout column>
                            <v-flex shrink>
                                <v-text-field
                                style="background-color: white; border-radius: 4px;"
                                flat
                                hide-details
                                label="Betreff"
                                v-model="msg.subject"
                                ></v-text-field>
                            </v-flex>
                            <v-flex grow>
                                <v-textarea
                                    style="background-color: white; border-radius: 4px;"
                                    flat
                                    no-resize
                                    hide-details
                                    label="Nachricht"
                                    v-model="msg.message"
                                ></v-textarea>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex shrink>
                        <v-layout column align-center>
                            <v-flex>
                                <v-btn class="send-button" @click="sendMessage" icon dark style="transform: rotate(-30deg);">
                                    <v-icon>
                                        send
                                    </v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex style="padding: 0 4px; color: white; font-size: 12px; width: 130px;">
                                <div>(Kein E-Mail-Versand)</div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex> -->
        </v-layout>
    </v-container>
    </v-dialog>
</template>

<script>
const RECEIVER_ID = 'receiverUserId';
const SENDER_ID = 'senderUserId';

export default {
    name: 'MessageWindow',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        receivers: Array,
        messages: Array,
        counts: Object
    },
    data: () => ({
        receiverListVisible: false,
        search: '',

        selectedReceiver: {
            receiverUserId: '',
            receiverEmail: ''
        },

        msg: {
            subject: '',
            message: ''
        },
        visibleDialog: false
    }),
    watch: {
        visibleDialog(value) {
            if(!value) this.closeWindow();
        },
        visible(value) {
            this.visibleDialog = value;
            if(this.selectedReceiver.receiverUserId == '' && this.filteredReceivers.length) {
                this.selectedReceiver = this.filteredReceivers[0];

            }
            this.scrollToLast();
        }
    },
    computed: {
        preparedMessages() {
            let messages = [];
            
            if(this.messages.length != 0) {
                let numberKeys = Object.keys(this.messages[0]).filter(key => typeof this.messages[0][key] == 'number');

                for(let msg of this.messages) {
                    if(msg[RECEIVER_ID] == this.selectedReceiver[RECEIVER_ID] || msg[SENDER_ID] == this.selectedReceiver[RECEIVER_ID]) {
                        let obj = msg;
                        for(let key of numberKeys) {
                            let formattedDate = new Date(obj[key]);
                            obj.date = formattedDate.toLocaleDateString();
                            obj.time = formattedDate.toLocaleTimeString()
                        }
                        messages.push(obj);
                    }
                }
            }
            return messages;
        },
        sortedReceivers() {
            let activatedReceivers = this.receivers.filter(receivers => receivers.isActivated == 1);
            let notActivatedReceivers = this.receivers.filter(receivers => receivers.isActivated == 0);

            let sortedActivatedReceivers = activatedReceivers.sort((rec1, rec2) => {
                return (rec1.lastname).localeCompare(rec2.lastname);
            });

            let sortedNotActivatedReceivers = notActivatedReceivers.sort((rec1, rec2) => {
                return (rec1.receiverEmail).localeCompare(rec2.receiverEmail);
            });

            return sortedActivatedReceivers.concat(sortedNotActivatedReceivers);
        },
        filteredReceivers() {
            let array = [];
            let self = this;
            if(this.sortedReceivers.length != 0) {
                for(let receiver of this.sortedReceivers) {
                    for(let key of Object.keys(receiver)) {
                        if(receiver[key] != null && typeof receiver[key] == 'string') {
                            if(receiver[key].toLowerCase().includes(this.search.toLowerCase())) {
                                array.push(receiver);
                                break;
                            }
                        }
                    }
                }
            }
            //if(array.length == 1) this.selectedReceiver = array[0];
            return array;
        },
    },
    methods: {
        scrollToLast() {
            if(!!document.getElementById('lastMessage')) {
                this.$vuetify.goTo('#lastMessage', {
                    duration: 0,
                    offset: 0,
                    easing: 'easeInOutCubic',
                    container: '#messages'
                });
            }
        },
        resetData() {
            this.search = '';
            this.msg = {
                subject: '',
                message: ''
            };
        },
        showNotReadCount(receiverId) {
            /*return this.messages.filter(msg => {
                return (msg[SENDER_ID] == receiverId || msg[RECEIVER_ID] == receiverId) && msg.msgState != 'read'
            }).length*/
            return this.counts[receiverId] ? this.counts[receiverId] : 0;
        },
        closeWindow() {
            this.$emit('close');
        },
        sendMessage() {
            this.$emit('send', Object.assign(this.msg, this.selectedReceiver));
            this.resetData();
        },
        readMessagesFrom(receiver) {
            if(this.preparedMessages.length != 0) {
                this.$emit('readMessagesFrom', receiver);
            }
        },
        selectReceiver(receiver) {
            this.selectedReceiver = receiver;
            this.readMessagesFrom(receiver);
        }
    }
}
</script>

<style scoped>
.selected-user {
    background-color: rgba(0,0,0,0.05);
}

.send-button:focus {
    border: 1px solid rgb(31, 81, 206);
    background-color:rgba(31, 81, 206, .3);
}
</style>